import { render } from "./ReportModal.vue?vue&type=template&id=6ba79870&scoped=true"
import script from "./ReportModal.vue?vue&type=script&lang=js"
export * from "./ReportModal.vue?vue&type=script&lang=js"

import "./ReportModal.vue?vue&type=style&index=0&id=6ba79870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba79870"]])

export default __exports__